



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { Paytype } from '../../models/paytype.model';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../services/alert.service';
import { CreateEditPaytypeModalComponent } from './create-edit-paytype-modal/create-edit-paytype-modal.component';
import { Router } from '@angular/router';

@Component({
    selector: 'paytypes',
    template: require('./paytypes.component.html'),
    styles: [require('./paytypes.component.css')],
    animations: [fadeInOut]
})
export class PaytypesComponent {
    paytypes: Paytype[];
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getPaytypes();
    }

    getPaytypes() {
        this.apiService.getPaytypes().subscribe(r => {
            this.paytypes = r;
        })
    }

    createEditPaytype(paytype: any) {
        let dialogRef = this.dialog.open(CreateEditPaytypeModalComponent, {
            width: '600px',
            data: {
                currentPaytype: paytype || {},
                //vendors: this.paytypes
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getPaytypes();
        })
    }

    deletePaytype(paytypeId: number) {
        this.alertService.showDialog("Do you want to delete this paytype ?", DialogType.confirm, val => {

            this.apiService.deletePaytype(paytypeId).subscribe(r => {
                this.getPaytypes();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/paytypes/' + event.row.paytypeId]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/paytypes/paytypes.component.ts